import styled from 'styled-components';
import Image from '@stencil/image';
import {
  CenteredSpaceWrap,
  FlexCentered,
  PrimaryLink,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const GoSafeSliderContainerWrap = styled.section(
  props => `
    max-width: 120rem;
    width: 100%;
    margin: ${props.theme.spacing.large} auto 0;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    background:${props.theme.colors.goWhite.base};
    `,
);

export const GoSafeLogoImg = styled(Image)(
  props => `
  width: ${props.width || '6rem'};
  `,
);

export const GoSafeSliderHeaderWrapper = styled(CenteredSpaceWrap)(
  props => `
    padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
    background-color: ${props.theme.colors.goGreen.light};
    border-top-left-radius: ${props.theme.misc.borderRadius.xxxlarge};
    border-top-right-radius: ${props.theme.misc.borderRadius.xxxlarge};
    `,
);

export const GoSafeSliderHeaderBtn = styled(PrimaryLink)(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:${props.customColor || props.theme.colors.goBrandBlue.base};
    `,
);

export const GoSafeSliderList = styled.ul(
  props => `
    display:flex;
    margin-top:${props.theme.spacing.xlarge};
    margin: ${props.theme.spacing.xlarge} 0 ${props.theme.spacing.large} ${
    props.theme.spacing.xlarge
  };
    position:relative;
    color:${props.theme.colors.downriver.base};
    font-size: ${props.theme.font.custom(14)};
    > li{
        margin-right:${props.theme.spacing.large};
        width:27.8rem;
        border: .1rem solid ${props.theme.colors.ash.medium};
        border-radius: 0 ${props.theme.misc.borderRadius.xxxlarge} ${
    props.theme.misc.borderRadius.xxxlarge
  } ${props.theme.misc.borderRadius.xxxlarge};
    }
    `,
);

export const GoSafeSliderListHeader = styled(FlexCentered)(
  props => `
    height:3rem;
    background:${props.theme.colors.goTeal.light};
    border-radius: ${props.theme.misc.borderRadius.large} ${props.theme.misc.borderRadius.large} ${props.theme.misc.borderRadius.large} 0;
    position:absolute;
    top:-1.5rem;
    `,
);

export const GoSafeSliderListHeaderText = styled.p(
  props => `
    font-weight:bold;
    padding:0 ${props.theme.spacing.base};
    `,
);

export const GoSafeSliderItemWrap = styled.ul(
  props => `
    margin-top:${props.theme.spacing.xlarge};
    list-style-type: disc;
    margin-left:${props.theme.spacing.xxlarge};
    >li{
        margin-bottom:${props.theme.spacing.small};
        &:last-child{
          margin-bottom:0;
        }
    }
    `,
);

export const GoSafeSliderItemMoreWrap = styled.span(
  props => `
    position:relative;
      `,
);

export const GoSafeSliderItemMoreList = styled.ul(
  props => `
  visibility: hidden;
  background-color: ${props.theme.colors.downriver.base};
  color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.base};
  width:22.7rem;

  /* Position the tooltip */
  position: absolute;
  left:0rem;
  top:3rem;
  >li{
    padding-bottom:${props.theme.spacing.small};
    &::before{
      content: "• ";
      color:${props.theme.colors.goWhite.base};
      width: 1rem;
    }
  }
  &::after{
    content: "";
    position: absolute;
    top: -1.5rem;
    left: 1.5rem;
    border-width: .8rem;
    border-style: solid;
    border-color: transparent transparent ${props.theme.colors.downriver.base} transparent;
  }
`,
);

export const GoSafeSliderItemMoreText = styled.button(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  cursor:pointer;
  margin-left:${props.theme.spacing.small};
  border:none;
  &:hover ~ ${GoSafeSliderItemMoreList} {
    visibility: visible;
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
`,
);

export const GoSafeSliderItemParaText = styled.p(
  props => `
    width:15rem;
      `,
);

export const GoSafeSliderItemParaWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-top:${props.theme.spacing.xlarge};
    padding: 0 ${props.theme.spacing.base};
    `,
);

export const GoSafeListItemLogo = styled(Image)(
  props => `
  z-index: ${props.theme.misc.zIndex.large};
  width:2.5rem;
  height:2.5rem;
  `,
);

export const GoSafeLogoBg = styled.div(
  props => `
    width: 3.3rem;
    height: 3rem;
    background:${props.theme.colors.goTeal.light};
    border-radius: ${props.theme.misc.borderRadius.xlarge} ${props.theme.misc.borderRadius.custom(
    15,
  )} ${props.theme.misc.borderRadius.custom(15)} 0;
    position: absolute;
    z-index: ${props.theme.misc.zIndex.xxsmall} ;
      `,
);

export const SliderArrowRight = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -2rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const SliderArrowLeft = styled.div(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -4rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const GoSafeSliderTitle = styled.div(
  props => `
  font-size: ${props.theme.font.custom(20)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  color: ${props.customColor || props.theme.colors.downriver.base}
`,
);

export const GosafeImg = styled(Image)(
  props => `
  width: 8rem;
  height: 2.5rem;
  object-fit: contain;
    `,
);

export const TextContentBoldSpan = styled.span(
  props => `
  font-weight: bold;
  padding-left:${props.theme.spacing.small};
`,
);

export const TextContentNormalSpan = styled.span(
  props => `
  font-size: ${props.theme.font.custom(16)};
  padding-left:${props.theme.spacing.small};
`,
);
